import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'

class Pin extends Component {
  static propTypes = {
    active: PropTypes.bool
  }

  render () {
    let className = this.props.active ? 'icon PinIcon active' : 'icon PinIcon'
    let title = this.props.lastUpdated
    if (!this.props.active && this.props.needsUpdating) {
      className = 'icon PinIcon needsUpdating'
      title += ' - needs updating'
    }
    return (
      <Icon {...this.props} className={className}>
        <svg width='12px' height='20px' viewBox='0 0 12 20'>
          <title>{title}</title>
          <g
            id='icons'
            stroke='none'
            strokeWidth='1'
            fillRule='evenodd'
            opacity='0.486998601'
          >
            <g
              transform='translate(-265.000000, -355.000000)'
              id='pin'
              className='icon__fill'
              fill='#7E8DA2'
            >
              <g transform='translate(265.000000, 355.000000)'>
                <polygon
                  id='Shape'
                  points='10 10 10 2 11 2 11 0 1 0 1 2 2 2 2 10 0 12 0 14 5.2 14 5.2 20 6.8 20 6.8 14 12 14 12 12'
                />
              </g>
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Pin
